import { buildModelManager } from "../builder.js";
const DefaultRecurringEnrollmentSelection = {
  __typename: true,
  id: true,
  clientId: true,
  createdAt: true,
  deletedAt: true,
  endedAt: true,
  lastServiceAt: true,
  nextReminderAt: true,
  optedIn: true,
  profileId: true,
  recurringServiceTypeId: true,
  reminderSentAt: true,
  sourceWorkItemId: true,
  updatedAt: true
};
const modelApiIdentifier = "recurringEnrollment";
const pluralModelApiIdentifier = "recurringEnrollments";
;
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultRecurringEnrollmentSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultRecurringEnrollmentSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultRecurringEnrollmentSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultRecurringEnrollmentSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultRecurringEnrollmentSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultRecurringEnrollmentSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultRecurringEnrollmentSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createRecurringEnrollment",
    operationReturnType: "CreateRecurringEnrollment",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      recurringEnrollment: { required: false, type: "CreateRecurringEnrollmentInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultRecurringEnrollmentSelection
  },
  {
    type: "action",
    operationName: "bulkCreateRecurringEnrollments",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkCreateRecurringEnrollmentsInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultRecurringEnrollmentSelection
  },
  {
    type: "action",
    operationName: "updateRecurringEnrollment",
    operationReturnType: "UpdateRecurringEnrollment",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      recurringEnrollment: { required: false, type: "UpdateRecurringEnrollmentInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultRecurringEnrollmentSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateRecurringEnrollments",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpdateRecurringEnrollmentsInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultRecurringEnrollmentSelection
  },
  {
    type: "action",
    operationName: "endRecurringEnrollment",
    operationReturnType: "EndRecurringEnrollment",
    functionName: "end",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      recurringEnrollment: { required: false, type: "EndRecurringEnrollmentInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultRecurringEnrollmentSelection
  },
  {
    type: "action",
    operationName: "bulkEndRecurringEnrollments",
    functionName: "bulkEnd",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "end",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkEndRecurringEnrollmentsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultRecurringEnrollmentSelection
  },
  {
    type: "action",
    operationName: "restoreRecurringEnrollment",
    operationReturnType: "RestoreRecurringEnrollment",
    functionName: "restore",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      recurringEnrollment: { required: false, type: "RestoreRecurringEnrollmentInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultRecurringEnrollmentSelection
  },
  {
    type: "action",
    operationName: "bulkRestoreRecurringEnrollments",
    functionName: "bulkRestore",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "restore",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkRestoreRecurringEnrollmentsInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultRecurringEnrollmentSelection
  },
  {
    type: "action",
    operationName: "upsertRecurringEnrollment",
    operationReturnType: "UpsertRecurringEnrollment",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      recurringEnrollment: { required: false, type: "UpsertRecurringEnrollmentInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateRecurringEnrollmentResult": { hasReturnType: false },
      "... on UpdateRecurringEnrollmentResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultRecurringEnrollmentSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertRecurringEnrollments",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpsertRecurringEnrollmentsInput!]"
      }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultRecurringEnrollmentSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "recurringEnrollmentGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const RecurringEnrollmentManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultRecurringEnrollmentSelection,
  operations
);
export {
  DefaultRecurringEnrollmentSelection,
  RecurringEnrollmentManager
};
//# sourceMappingURL=RecurringEnrollment.js.map
